import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from 'react';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix for default marker icons
const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -41],
});
L.Marker.prototype.options.icon = DefaultIcon;

interface MapProps {
    center: [number, number];
    zoom: number;
    locationError: string;
}

// Component to recenter map
const RecenterAutomatically = ({ lat, lng }: { lat: number; lng: number }) => {
    const map = useMap();
    useEffect(() => {
        map.setView([lat, lng]);
    }, [lat, lng, map]);
    return null;
};

const Map: React.FC<MapProps> = ({ center, zoom, locationError = [] }) => {

    // Ensure Leaflet works properly with React strict mode
    useEffect(() => {
        const L = window.L;
        if (L) {
            L.Icon.Default.imagePath = "https://unpkg.com/leaflet@1.9.4/dist/images/";
        }
    }, []);

    return (
        <div className="w-full space-y-4 mt-4 -z-0">
            {locationError && (
                <p className="text-red-500">{locationError}</p>
            )}
            
            <div className="w-full h-96 rounded-lg overflow-hidden shadow-lg">
                <MapContainer
                    center={center}
                    zoom={zoom}
                    className="w-full h-full"
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    
                    {/* User location marker */}
                    {center && (
                        <>
                            <Marker position={center}>
                                <Popup>Lokasi Anda sekarang!</Popup>
                            </Marker>
                            <RecenterAutomatically lat={center[0]} lng={center[1]} />
                        </>
                    )}
                </MapContainer>
            </div>
        </div>
    );
};

export default Map;